import api from "../../axiosConfig";

export const addPrintSettings = async (formData,doctor_id) => {

    try {

      const response = await api.post(`/setting/add-update/${doctor_id}`, formData);
      const resData = response?.data;
      console.log('Response data:', resData);
  
      if (resData?.success_type === 'success'|| resData?.message_type === 'success') {
        
        return { success: true, data: resData?.data };
      } else {
        return { success: false, error: resData.message };
      }
    } catch (err) {
      throw new Error(err.response?.data?.message || 'Login error');
    }
  };


export const getPrintSettings = async (doctor_id) => {
  try {
    const response = await api.get(`/setting/get/${doctor_id}`)

    const resData = response?.data;
    console.log('Response data:', resData);

    if (resData?.success_type === 'success'|| resData?.message_type === 'success') {
      return { success: true, data: resData?.data };
    } else {
      return { success: false, error: resData.message };
    }
  } catch (err) {
    throw new Error(err.response?.data?.message || 'Error fetching SHifts');
  }
};

export const updatePrintSettings = async (doctor_id, formData) => {


  try {
    const response = await api.post(`/setting/add-update/${doctor_id}`, formData);

    const resData = response?.data;
    console.log('Update shifts response:', resData);
    
    if (resData?.success_type === 'success'|| resData?.message_type === 'success') {
      return { success: true, data: resData?.data };
    } else {
      return { success: false, error: resData.message };
    }
  } catch (err) {
    throw new Error(err.response?.data?.message || 'Error updating shift');
  }
};
